import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AccessPageService } from './access-page.service';

export const accessPageGuard: CanActivateFn = (route) => {
  const userService = inject(AccessPageService);

  return userService.canActivate(route?.data['permissions']);
};
